import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'

Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'index',

        component: index,
        meta: {
            // 页面标题title
            title: ''
        }
    },

    {
        path: '/jgDetails',
        name: 'jgDetails',
        component: () => import( /* webpackChunkName: "about" */ '../views/jgDetails/jgDetails.vue'),
        meta: {
            // 页面标题title
            title: '机构详情'
        }
    },
    {
        path: '/backstage',
        name: 'backstage',
        component: () => import( /* webpackChunkName: "about" */ '../views/backstage/backstage.vue'),
        meta: {
            // 页面标题title
            title: ''
        }
    },
    {
        path: '/hjindex',
        name: 'hjindex',
        component: () => import( /* webpackChunkName: "about" */ '../views/hjindex/hjindex.vue'),
        meta: {
            // 页面标题title
            title: '环境损害类'
        }
    },
    {
        path: '/sxindex',
        name: 'sxindex',
        component: () => import( /* webpackChunkName: "about" */ '../views/sxindex/sxindex.vue'),
        meta: {
            // 页面标题title
            title: '声像资料类'
        }
    },
    {
        path: '/wzindex',
        name: 'wzindex',
        component: () => import( /* webpackChunkName: "about" */ '../views/wzindex/wzindex.vue'),
        meta: {
            // 页面标题title
            title: '物证类'
        }
    },
    {
        path: '/fyindex',
        name: 'fyindex',
        component: () => import( /* webpackChunkName: "about" */ '../views/fyindex/fyindex.vue'),
        meta: {
            // 页面标题title
            title: '法医类'
        }
    },
    {
        path: '/jdyth',
        name: 'jdyth',
        component: () => import( /* webpackChunkName: "about" */ '../views/jdyth/jdyth.vue'),
        meta: {
            // 页面标题title
            title: '鉴定一体化'
        }
    },

    {
        path: '/sfjgcx',
        name: 'sfjgcx',
        component: () => import( /* webpackChunkName: "about" */ '../views/sfjgcx/sfjgcx.vue'),
        meta: {
            // 页面标题title
            title: '司法鉴定机构查询'
        }
    },
    {
        path: '/jdlhfwt',
        name: 'jdlhfwt',
        component: () => import( /* webpackChunkName: "about" */ '../views/jdlhfwt/jdlhfwt.vue'),
        meta: {
            // 页面标题title
            title: '鉴定联合服务团'
        }
    },
    {
        path: '/jdapply',
        name: 'jdapply',
        component: () => import( /* webpackChunkName: "about" */ '../views/jdapply/jdapply.vue'),
        meta: {
            // 页面标题title
            title: '鉴定申请'
        }
    },
    {
        path: '/jdwshy',
        name: 'jdwshy',
        component: () => import( /* webpackChunkName: "about" */ '../views/jdwshy/jdwshy.vue'),
        meta: {
            // 页面标题title
            title: '鉴定文书核验'
        }
    },
    {
        path: '/questions',
        name: 'questions',
        component: () => import( /* webpackChunkName: "about" */ '../views/questions/questions.vue'),
        meta: {
            // 页面标题title
            title: '问题咨询'
        }
    },
    {
        path: '/grht',
        name: 'grht',
        component: () => import( /* webpackChunkName: "about" */ '../views/grht/grht.vue'),
        meta: {
            // 页面标题title
            title: '鉴定申请-个人后台'
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import( /* webpackChunkName: "about" */ '../views/register/register.vue'),
        meta: {
            // 页面标题title
            title: '鉴定申请注册'
        }
    },

    {
        path: '/aboutxh',
        name: 'aboutxh',
        component: () => import( /* webpackChunkName: "about" */ '../views/aboutxh/aboutxh.vue'),
        meta: {
            // 页面标题title
            title: '关于协会'
        }
    },
    {
        path: '/news',
        name: 'news',
        component: () => import( /* webpackChunkName: "about" */ '../views/news/news.vue'),
        meta: {
            // 页面标题title
            title: '工作交流'
        }
    },
    {
        path: '/train',
        name: 'train',
        component: () => import( /* webpackChunkName: "about" */ '../views/train/train.vue'),
        meta: {
            // 页面标题title
            title: '学习培训'
        }
    },
    {
        path: '/tzgg',
        name: 'tzgg',
        component: () => import( /* webpackChunkName: "about" */ '../views/tzgg/news.vue'),
        meta: {
            // 页面标题title
            title: '通知公告'
        }
    },
    {
        path: '/hydt',
        name: 'hydt',
        component: () => import( /* webpackChunkName: "about" */ '../views/hydt/news.vue'),
        meta: {
            // 页面标题title
            title: '行业动态'
        }
    },
    {
        path: '/dxal',
        name: 'dxal',
        component: () => import( /* webpackChunkName: "about" */ '../views/dxal/news.vue'),
        meta: {
            // 页面标题title
            title: '典型案例'
        }
    },

    {
        path: '/jgmap',
        name: 'jgmap',
        component: () => import( /* webpackChunkName: "about" */ '../views/jgmap/jgmap.vue'),
        meta: {
            // 页面标题title
            title: '机构地图'
        }
    },
    {
        path: '/newsDetails',
        // name: 'index',
        component: () => import( /* webpackChunkName: "about" */ '../views/newsDetails/newsDetails.vue'),
        meta: {
            // 页面标题title
            title: '新闻详情'
        }
    },
    {
        path: '/flfg',
        name: 'flfg',
        component: () => import( /* webpackChunkName: "about" */ '../views/flfg/news.vue'),
        meta: {
            // 页面标题title
            title: '法律法规'
        }
    },
    {
        path: '/jdfw',
        name: 'jdfw',
        component: () => import( /* webpackChunkName: "about" */ '../views/jdfw/news.vue'),
        meta: {
            // 页面标题title
            title: '鉴定服务'
        }
    }
]

const router = new VueRouter({
    routes
})

export default router
